/**
 * Tiny browser-local pub/sub for Front Row feed invalidation.
 *
 * Publishers: after any operation that mutates the engine's feed
 * (e.g. Email Pipeline `commit`), call `postFeedInvalidated()`.
 *
 * Subscribers: FrontRowContext listens on mount and calls
 * `refreshFeed()` when a message arrives.
 *
 * Cross-tab + same-tab safe. Silent no-op in browsers without
 * BroadcastChannel (unit tests / SSR).
 */
const CHANNEL_NAME = "frontrow";
const FEED_INVALIDATED = "feed_invalidated";

let _channel = null;
function _get() {
  if (_channel) return _channel;
  if (typeof window === "undefined" || typeof BroadcastChannel === "undefined") {
    return null;
  }
  _channel = new BroadcastChannel(CHANNEL_NAME);
  return _channel;
}

export const postFeedInvalidated = (reason = "commit") => {
  const c = _get();
  if (!c) return;
  try {
    c.postMessage({ type: FEED_INVALIDATED, reason, at: Date.now() });
  } catch {
    /* channel may be closed during teardown — safe to ignore */
  }
};

/**
 * Subscribe. Returns an unsubscribe function.
 * The callback receives the raw message payload.
 */
export const onFeedInvalidated = (cb) => {
  const c = _get();
  if (!c) return () => {};
  const handler = (event) => {
    if (event?.data?.type === FEED_INVALIDATED) cb(event.data);
  };
  c.addEventListener("message", handler);
  return () => c.removeEventListener("message", handler);
};
